import { Fragment, useEffect, useState } from "react"
import {
    CloseOutlined,
    MenuOutlined,
} from '@ant-design/icons';
import MenuBtnExpanded from "./MenuBtnExpanded";

const MenuBtn = props => {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        let btn = document.getElementById('menu-btn')
        const addAnimation = () => {
            btn.classList.add('menu-button-animation')

            const onAnimationEnd = () => {
                btn.classList.remove('menu-button-animation')
                btn.removeEventListener('animationend', onAnimationEnd)
            }
            btn.addEventListener('animationend', onAnimationEnd)
        }
        btn.addEventListener('click', addAnimation)

        return () => window.removeEventListener('click', addAnimation)
    }, [open])

    return <Fragment>
        <div
            id="menu-btn"
            className="menu-button"
            onClick={() => setOpen(!open)}
        >
            {open ? <CloseOutlined /> : <MenuOutlined />}
        </div>
        {open && <MenuBtnExpanded {...props} />}
    </Fragment>
}

export default MenuBtn
